import React from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Grid, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import DropdownAnimation from '../_assets/_lottie/dropdown.json';
import ModalAnimation from '../_assets/_lottie/modal.json';

import Illustration from './_illustration';

const styles = cssMap({
	root: {
		// On mobile, each element is full width.
		gridTemplateColumns: '1fr',
		'@media (min-width: 30rem)': {
			// On larger viewports, they are laid out in two columns.
			gridTemplateColumns: '1fr 1fr',
		},
		paddingBlockStart: token('space.400'),
		paddingBlockEnd: token('space.400'),
	},
});

/**
 * Transitions
 *
 * This component displays a grid of transitions with their corresponding labels and descriptions.
 * It uses the Illustration component to display the lottie animations.
 */
const Transitions = (): React.JSX.Element => {
	return (
		<Grid testId="grid-basic" xcss={styles.root} rowGap="space.150" columnGap="space.150">
			<Stack space="space.100">
				<Heading size="xsmall">Dropdown entrance, 150ms</Heading>
				<Illustration
					lottieFile={DropdownAnimation}
					size="small"
					hasSpacing={false}
					label="Cursor clicking a Dropdown menu sliding down from its 'Create' trigger."
				/>
			</Stack>
			<Stack space="space.100">
				<Heading size="xsmall">Modal entrance, 250ms</Heading>
				<Illustration
					lottieFile={ModalAnimation}
					size="small"
					hasSpacing={false}
					label="Cursor triggering a Modal dialog centred on screen."
				/>
			</Stack>
		</Grid>
	);
};

export default Transitions;
